import { FC } from 'react';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    content: React.ReactNode;
};

export const NotificationsAssignments: FC<propsType> = ({ content }) => {
    const isDarkMode = useGetIsDarkMode();

    return (
        <div className={`border rounded ${isDarkMode ? 'bg-lightdark' : 'bg-lightgrey'} p-3`}>
            <h2 className={`text-center ${isDarkMode ? 'text-white' : ''} border-top border-bottom py-1 mt-4 mb-5`}>
                ASIGNADOS
            </h2>
            {content}
        </div>
    );
}
